import React, { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const CompactLogo = () => (
  <div className="flex items-center gap-2.5 leading-none">
    <span className="font-display text-2xl sm:text-3xl text-white tracking-[0.06em] relative inline-block">
      KOEHN
      <span className="absolute left-0 right-0 top-1/2 h-[2px] bg-white/80" aria-hidden="true" />
    </span>
    <span className="hidden sm:flex flex-col leading-[0.95] border-l border-white/15 pl-2.5">
      <span className="font-display text-base text-[#3B9BE8] tracking-[0.08em]">HEADLIGHT</span>
      <span className="font-display text-base text-white tracking-[0.08em]">RESTORATION</span>
    </span>
  </div>
);

const NAV = [
  { label: "Why Us", id: "why", testid: LANDING.navServices },
  { label: "Process", id: "process", testid: LANDING.navProcess },
  { label: "Service Area", id: "area", testid: LANDING.navArea },
  { label: "Pricing", id: "pricing", testid: LANDING.navPricing },
  { label: "Contact", id: "contact", testid: LANDING.navContact },
];

export const Header = ({ phone, onQuote }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-300 ${
        scrolled ? "bg-[#070B14]/90 backdrop-blur border-b border-white/8" : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <button data-testid={LANDING.headerLogo} onClick={() => go("top")} className="shrink-0">
            <CompactLogo />
          </button>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={n.testid}
                onClick={() => go(n.id)}
                className="px-3 py-2 text-sm text-white/75 hover:text-white rounded-lg hover:bg-white/5 transition-colors"
              >
                {n.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              data-testid={LANDING.headerCallNow}
              href={`tel:${phone}`}
              className="hidden sm:inline-flex items-center gap-2 h-10 px-4 rounded-xl bg-[#3B9BE8] text-[#070B14] font-bold text-sm hover:bg-[#2F8FE0] transition-colors"
            >
              <Phone className="h-4 w-4" /> 785-288-1434
            </a>
            <button
              className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-xl border border-white/12 text-white"
              data-testid={LANDING.mobileMenuButton}
              onClick={() => setOpen((v) => !v)}
              aria-label="Menu"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/8 bg-[#070B14]/97 backdrop-blur">
          <div className="max-w-6xl mx-auto px-4 py-3 flex flex-col">
            {NAV.map((n) => (
              <button
                key={n.id}
                onClick={() => go(n.id)}
                className="text-left py-3 px-2 text-white/80 hover:text-white border-b border-white/5"
              >
                {n.label}
              </button>
            ))}
            <a
              href={`tel:${phone}`}
              className="mt-3 inline-flex items-center justify-center gap-2 h-11 rounded-xl bg-[#3B9BE8] text-[#070B14] font-bold"
            >
              <Phone className="h-4 w-4" /> Call 785-288-1434
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
